import cx from 'classnames'
import Collapse, { Panel } from 'rc-collapse'
import * as React from 'react'

import { angleDown, angleUp } from '../../icons'
import type { AccordionItemViewModel } from '../../view-models/AccordionItemViewModel'
import Icon from '../Icon/Icon'
import styles from './accordion-style.css'
type Props = {
  items: Array<AccordionItemViewModel>
  accordion?: boolean
  className?: string
}
type State = {
  time: number
  activeKey: Array<string>
}

const expandIcon = ({ isActive }) => {
  return (
    <div className={styles.expandIcon}>
      <Icon iconSrc={isActive ? angleUp : angleDown} width={'8px'} />
    </div>
  )
}

class Accordion extends React.Component<Props, State> {
  static displayName = 'Accordion'
  static defaultProps = {}
  state = {
    time: 4,
    activeKey: [],
  }

  handleChange = (activeKey: Array<string>) => {
    this.setState({
      activeKey,
    })
  }

  getItems(): Array<React.ReactNode> | null | undefined {
    const { items } = this.props
    if (!items) return null

    return items.map((child, index) => (
      <Panel
        forceRender={true}
        header={child.header}
        key={`accordion-panel-${index}`}
        expandIcon={expandIcon}
      >
        {child.component}
      </Panel>
    ))
  }

  render() {
    const { accordion, className } = this.props
    const activeKey = this.state.activeKey

    return (
      <div className={cx(styles.accordion, className && className)}>
        <Collapse
          accordion={accordion}
          onChange={this.handleChange}
          activeKey={activeKey}
          expandIcon={expandIcon}
        >
          {this.getItems()}
        </Collapse>
      </div>
    )
  }
}

export default Accordion